(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("event-emitter"));
	else if(typeof define === 'function' && define.amd)
		define(["event-emitter"], factory);
	else if(typeof exports === 'object')
		exports["TabCommunicator"] = factory(require("event-emitter"));
	else
		root["TabCommunicator"] = factory(root["_"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__) {
return 